import { useEffect, useState } from 'react';
import { Checkbox } from '../../areas/app/Checkbox';
import { LinuxServicesServerRowActions } from './LinuxServicesServerRowActions';
import { IManagingLinuxServiceInstance } from '../../api/models';
import { LinuxServiceAction } from '../../constants/LinuxServiceAction';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ServerApplicationClientEventSummary } from '../../signalr/models';
import { ApplicationLastDiscoveredTimestamp } from '../ApplicationServerManagement/ApplicationLastDiscoveredTimestamp';
import LinuxServiceLoadState from './LinuxServiceLoadStateText';
import LinuxServiceSubState from './LinuxServiceSubStateText';
import LinuxServiceActiveState from './LinuxServiceActiveStateText';

export interface LinuxServicesServerRowProps {
    selected: boolean;
    selectionChangedCallback: Function;
    serverApp: IManagingLinuxServiceInstance;
    userPrincipal: UserPrincipal;
    serverUserPrincipal: UserPrincipal;
    onClickCallback: (action: LinuxServiceAction) => Promise<void>;
    onTimeoutCallback: (data: ServerApplicationClientEventSummary) => void;
}

export function LinuxServicesServerRow(props: LinuxServicesServerRowProps) {
    const [selected, setSelected] = useState(false);

    const serverApp = props.serverApp;

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    return (
        <tr>
            <td>
                <Checkbox selected={selected} selectionChangedCallback={(checked: boolean) => props.selectionChangedCallback(checked, serverApp.serverName)} />
            </td>
            <td className="details-link">
                <ApplicationLastDiscoveredTimestamp serverApp={serverApp} />
            </td>
            <td>{serverApp.environment}</td>
            <td>
                <LinuxServiceLoadState {...serverApp} />
            </td>
            <td>
                <LinuxServiceActiveState {...serverApp} />
            </td>
            <td>
                <LinuxServiceSubState {...serverApp} />
            </td>
            <LinuxServicesServerRowActions
                serverApp={serverApp}
                userPrincipal={props.userPrincipal}
                serverUserPrincipal={props.serverUserPrincipal}
                onClickCallback={props.onClickCallback}
                onTimeoutCallback={props.onTimeoutCallback}
            ></LinuxServicesServerRowActions>
        </tr>
    );
}
